import { rawHirerAccountInfo } from '../services/mockDataService/mockHeaderFooterContext';

export const getLocalAccountInfo = () => {
  let account: any = {};
  account = rawHirerAccountInfo;
  return account;
};
